var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-kr",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0.67,
    d: "M0 0h512v512H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M610.61 511.56h-730.17v-512h730.17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.871 256.021a112.507 112.507 0 1 1-225.014 0 112.507 112.507 0 1 1 225.014 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.011 262.55a145.262 146.803 0 1 1-290.523 0 145.262 146.803 0 1 1 290.523 0z",
    fill: "#c70000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zm27.399 23.687l83.66-96.77 19.82 17.135-83.66 96.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zm55.384 47.88l83.66-96.77 19.82 17.136-83.66 96.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-49.417 126.44l83.66-96.77 19.821 17.135-83.66 96.771zm508.83-96.802l83.002 97.335-19.937 17-83.002-97.334zm-55.706 47.503l83.002 97.335-19.936 17-83.002-97.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.55 133.19l78.602-67.814 14.641 16.953-83.996 75.519-9.247-24.659z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.228 372.013l-80.416 95.829-19.716-16.4 80.417-95.828zM431.853 53.14l83.002 97.334-19.936 17.001-83.002-97.334zm109.622 341.536l-80.417 95.829-19.715-16.399 80.417-95.829zm-55.085-45.819l-80.417 95.83-19.715-16.4 80.416-95.829z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.6 236.68c4.592 36.974 11.297 78.175 68.199 82.455 21.328 1.278 62.817-5.074 77.061-63.19 18.688-55.829 74.975-71.88 113.28-41.613 21.718 14.166 27.727 36.666 29.283 53.557-1.739 54.243-32.874 101.2-72.823 122.14-45.93 27.3-109.56 27.87-165.3-13.49-25.12-23.57-60.219-67.02-49.7-139.86z",
    fill: "#3d5897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.91 370.59l78.734 67.661-14.591 16.997-87.156-71.851 23.013-12.807z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1.887 357.197l83.002 97.335-19.937 17-83.002-97.334z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-16.188 437.25l78.602-67.814 14.641 16.953-83.996 75.519-9.247-24.659z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.672 333.696l83.003 97.334-19.937 17-83.002-97.334zm-55.705 47.503l83.002 97.334-19.936 17L-49.97 398.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKr);
export default __webpack_public_path__ + "static/media/kr.c652c7b635b9c2b5d56472f97ff89c06.svg";
export { ForwardRef as ReactComponent };